export const BIOMETRIC_EN = {
  title: "Biometric Data & Consent Policy",
  version: "2.0",
  updated: "2026-06-12",
  intro:
    "This is a separate, binding policy explaining how HELCOO processes face biometrics, which are \"special category\" / sensitive personal data under GDPR (Art. 9), UK GDPR, the Saudi PDPL and UAE PDPL, and U.S. biometric privacy laws such as Illinois BIPA and Texas CUBI. Face verification is never enabled for an employee without their explicit consent. Contact: support@helcoo.uk.",
  sections: [
    {
      h: "1. Exactly what we collect",
      p: [
        "A live face image captured at the moment of check-in or check-out, together with liveness signals confirming a real person is present and preventing spoofing with photos, video or masks.",
        "A derived face template: an encrypted mathematical representation that cannot be reversed into an image and is used solely for matching.",
        "We do not collect fingerprints, iris scans, voiceprints or any other biometric identifier.",
      ],
    },
    {
      h: "2. The single purpose",
      p: [
        "To verify that the person checking in is the employee themselves and to prevent attendance fraud. Nothing else.",
        "Biometric data is never used for advertising, marketing, profiling, performance scoring or identifying people in public spaces; it is never used to train any AI model for us or any third party; and it is never sold, leased, traded or otherwise monetised.",
      ],
    },
    {
      h: "3. Explicit consent and withdrawal",
      p: [
        "Before the first reference image is enrolled, the employee is shown a clear in-app notice and must actively consent. Consent is optional and separate from accepting the general terms, and a record of the consent date and version is stored.",
        "Consent can be withdrawn at any time from app settings or by emailing support@helcoo.uk. On withdrawal the face template and all reference images are deleted immediately, face verification stops, and the employee moves to an alternative check-in method defined by the employer.",
        "Withdrawing consent does not erase past attendance records, which are employment and financial records required by law, but it does erase all biometric data.",
      ],
    },
    {
      h: "4. Roles and responsibility",
      p: [
        "The employer (subscribing company) is the data controller and is legally responsible for informing employees, obtaining consent under local law, and offering a non-discriminatory alternative for anyone who declines.",
        "HELCOO is the processor and processes data only on the employer's instructions and for operating the service; our staff access it only within narrow, logged support scenarios.",
      ],
    },
    {
      h: "5. Retention and destruction",
      p: [
        "The face template is retained while the employee has an active account and valid consent.",
        "It is destroyed immediately upon any of: withdrawal of consent, deletion of the employee, in-app account deletion, termination of the company's subscription, or one year after the account was last used — whichever occurs first.",
        "Live images captured at each verification are used for immediate matching and retained only for a limited period for audit and anti-fraud purposes, then deleted automatically.",
      ],
    },
    {
      h: "6. Processors and security",
      p: [
        "Matching and liveness detection are performed by Amazon Rekognition (AWS) under a data processing agreement; AWS is not permitted to use this data for its own purposes.",
        "Data is encrypted in transit with TLS and encrypted at rest, access is role-restricted and recorded in tamper-evident audit logs, and each company's data is isolated from every other company.",
      ],
    },
    {
      h: "7. Your rights and complaints",
      p: [
        "You have the right to access, obtain a copy of, rectify and erase your biometric data, to object to its processing and to withdraw consent, free of charge and without any impact on your service.",
        "To exercise any of these rights: support@helcoo.uk — we respond within 30 days. You also have the right to complain to your local supervisory authority (for example the ICO in the United Kingdom).",
      ],
    },
  ],
};
